import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useMenu } from 'src/contexts/menu-context'
import { LEVELS } from '../constants'
import { AlphabeticalMenu } from './MenuComponents/AlphabeticalMenu'
import { ListMenu } from './MenuComponents/ListMenu/ListMenu'

export const SecondLevel = () => {
  const { state } = useMenu()
  const { updatedMenu } = useGlobalNavigation()

  if (
    typeof state.firstLevelItem?.index !== 'number' ||
    !updatedMenu[state.firstLevelItem.index]?.isMobile
  )
    return null

  return (
    <div className="navigation-panel-step active">
      {typeof state.firstLevelItem?.index === 'number' &&
        updatedMenu[state.firstLevelItem.index]?.nextLevel?.items !== null &&
        (updatedMenu[state.firstLevelItem.index]?.nextLevel
          ?.alphabeticalMenu ? (
          <AlphabeticalMenu
            menu={updatedMenu[state.firstLevelItem.index]?.nextLevel}
          />
        ) : (
          <ListMenu
            menu={updatedMenu[state.firstLevelItem.index]?.nextLevel}
            type={LEVELS.second_level.toString()}
          />
        ))}
    </div>
  )
}
